
//locale
/*
const UrlCallApi = 'http://localhost:8080/api/'
const BaseHttp   =  'http://localhost:3000/'
const BaseHttpFe   =  'http://localhost:3000/'
//const BasePoligon =  'mumbai.';
//const Analititcs =  'G-BRC9ET8FQM';
//const AnalititcsREP ='710fa50e-2106-466c-998c-4f7f4bb129cf';
const Ambiente =  'TEST';
*/


//test
/*
const UrlCallApi = 'https://test.itachain.com/bck/api/'
const BaseHttp =  'https://test.itachain.com/bck/'
const BaseHttpFe =  'https://test.itachain.com/'
//const BasePoligon =  'mumbai.';
const Analititcs =  'G-BRC9ET8FQM';
const AnalititcsREP ='710fa50e-2106-466c-998c-4f7f4bb129cf/page/qYmAD';
const Ambiente =  'TEST';
*/

//prod
/*
const UrlCallApi = 'https://itachain.com/bck/api/'
const BaseHttp =  'https://itachain.com/bck/'
const BaseHttpFe =  'https://itachain.com/'
//const BasePoligon =  '';
const Analititcs =  'G-NXDGZR72CX';
const AnalititcsREP ='54f1f940-09e1-4d90-8697-ebc0b5acae9b/page/eZKCD';
const Ambiente =  'PROD';
*/

//TRACKIT

const UrlCallApi = 'https://provy.blockchainitalia.io/prv/api/'
const BaseHttp =  'https://provy.blockchainitalia.io/prv/'
const BaseHttpFe =  'https://provy.blockchainitalia.io/'
//const BasePoligon =  'mumbai.';
//const Analititcs =  'G-BRC9ET8FQM';
//const AnalititcsREP ='710fa50e-2106-466c-998c-4f7f4bb129cf/page/qYmAD';
const Ambiente =  'TRACKIT';

const impFormatter = new Intl.NumberFormat('it-IT', {style: 'currency',currency: 'EUR'})
const numFormatter = new Intl.NumberFormat('it-IT', {})


module.exports = {
  UrlCallApi: UrlCallApi,
  BaseHttp: BaseHttp,
  BaseHttpFe:BaseHttpFe,
  //BasePoligon: BasePoligon,
  //Analititcs: Analititcs,
  //AnalititcsREP: AnalititcsREP,
  Ambiente:Ambiente,
  impFormatter:impFormatter,
  numFormatter:numFormatter,
}
